import React from 'react';
import { EscrowSummary } from '../../../components';
import { ContextProvider } from '../../../utils';
const EscrowAnalysisSummary = _ref => {
  let {
    logUserEvent,
    logApiEvent,
    url,
    authToken,
    xApiKey,
    loanNumber,
    onStatementsLinkClick,
    onPayNowClick,
    onLearnMoreClick,
    state
  } = _ref;
  return /*#__PURE__*/React.createElement(ContextProvider, null, /*#__PURE__*/React.createElement(EscrowSummary, {
    onLearnMoreClick: onLearnMoreClick,
    onStatementsLinkClick: onStatementsLinkClick,
    onPayNowClick: onPayNowClick,
    logUserEvent: logUserEvent,
    logApiEvent: logApiEvent,
    url: url,
    xApiKey: xApiKey,
    authToken: authToken,
    loanNumber: loanNumber,
    state: state
  }));
};
export default EscrowAnalysisSummary;
//# sourceMappingURL=index.js.map